import { InjectionToken } from '@angular/core';

export const TENANT_CONFIG = new InjectionToken<TenantConfig>('tenant-config');

export interface TenantConfig {
  /**
   * List of tenant name mappings
   */
  tenantMapping: Map<string, string>;
}

export const tenantConfig: TenantConfig = {
  tenantMapping: new Map([
    ['italent', 'open']
  ])
};
